const isDevelopment = process.env.NODE_ENV === 'development';

// The backend is served from the same host as the shell in every deployed
// environment (dev, staging, prod), so a deployed build calls its own origin.
// A hardcoded host makes every other environment's calls cross-origin to it.
export const BACKEND_BASE_URL = isDevelopment
  ? 'http://localhost:7007'
  : window.location.origin;
